<template>
    <div>
        <kgr-empty
            v-if="areas.length === 0"
            :value="$t('Keine Bereiche vorhanden')"
        />

        <div v-else>
            <kgr-areas-table
                v-if="view === 'list'"
                :areas="areas"
                :filter="filter"
            />

            <kgr-areas-grid
                v-if="view === 'grid'"
                :areas="areas"
                :filter="filter"
            />
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import KgrAreasGrid from './AreasGrid';
import KgrAreasTable from './AreasTable';

export default {
    name: 'KgrAreaList',
    components: {
        'kgr-areas-table': KgrAreasTable,
        'kgr-areas-grid': KgrAreasGrid,
        'kgr-empty': EmptyData,
    },
    props: {
        areas: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
            default: null,
        },
        view: {
            type: String,
            required: true,
        },
    },
};
</script>
